import { connect } from "react-redux";

import AnswerComplete from "components/answer/AnswerComplete";
import { openErrorDialog } from "redux/modules/errorDialog";
import { setPrevPage } from "redux/modules/answer/answerOther";
import { changeFreeCommentText } from "redux/modules/answer/answerResult";
import { closeCompleteDialog, openCompleteDialog } from "../../redux/modules/completeDialog";

const mapStateToProps = state => ({
  answerHeader: state.answerHeader,
  locale: state.answerResult.locale
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  showErrorDialog: () => {
    dispatch(openErrorDialog(new Error("authError")));
  },
  resetFreeComments: () => {
    dispatch(changeFreeCommentText("freeComment1", ""));
    dispatch(changeFreeCommentText("freeComment2", ""));
    dispatch(setPrevPage());
  },
  confirmBrowserBackDialog: () => {
    const dialogData = {
      title: "確認",
      contentText: "アンケート開始画面に戻ります。よろしいですか？",
      btnOKLabel: "はい",
      btnCancelLabel: "キャンセル",
      handleOpenClick: () => {
        dispatch(changeFreeCommentText("freeComment1", ""));
        dispatch(changeFreeCommentText("freeComment2", ""));
        dispatch(setPrevPage());
        dispatch(closeCompleteDialog());
        ownProps.history.push("/answer/start");
        window.history.pushState(null, "", "/answer/start");
      },
      handleCloseClick: () => {
        dispatch(closeCompleteDialog());
        ownProps.history.push(ownProps.location.pathname);
      }
    };

    dispatch(openCompleteDialog(dialogData));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AnswerComplete);



// WEBPACK FOOTER //
// ./src/containers/answer/AnswerCompleteContainer.jsx